/*
 I controlli sui campi del profilo azienda che non sono un semplice "non vuoto". Vivono qui, e non
 dentro la pagina, perche' sono regole di dominio con un confine preciso, e il confine si legge nei
 test accanto invece che dentro una catena di `if` lunga una schermata.

 Si controlla la forma, non l'esistenza: niente carattere di controllo della partita IVA, nessuna
 interrogazione all'Agenzia delle Entrate, nessuna verifica che il numero squilli. Il controllo
 serve a fermare il refuso — il campo lasciato a meta', il "123" battuto per provare — prima che
 finisca a database, dove questi due campi identificano l'azienda e il suo referente.

 Lo spazio intorno non e' un errore di chi scrive: si toglie prima di guardare.
*/
const PARTITA_IVA = /^[0-9]{11}$/;
const CODICE_FISCALE = /^[A-Za-z0-9]{16}$/;
const TELEFONO = /^[0-9]{9,10}$/;

/*
 Il campo `vatNumber` accoglie due cose diverse: la partita IVA, undici cifre, oppure il codice
 fiscale, sedici caratteri alfanumerici, che e' cio' che identifica una ditta individuale.

 Attenzione: la colonna `company.vat_number` a database e' `varchar(11)`, quindi un codice fiscale
 di sedici caratteri non ci sta. Qui resta accettato perche' e' la regola giusta del dominio e
 perche' i valori gia' a database vanno letti senza accusarli, ma finche' la colonna non si allarga
 il campo a video non ne lascia digitare piu' di undici.
*/
export function partitaIvaOCodiceFiscaleValido(
  valore: string | undefined | null,
): boolean {
  const codice = (valore || "").trim();
  return PARTITA_IVA.test(codice) || CODICE_FISCALE.test(codice);
}

/*
 Il telefono del referente: nove o dieci cifre, cioe' il numero italiano senza prefisso
 internazionale. Il tetto sono le dieci cifre della colonna `user.phone`, `varchar(10)`: un `+39`
 davanti non ci starebbe, e accettarlo qui vorrebbe dire salvarlo troncato.

 Ed e' facoltativo: il campo vuoto passa. Prima di BUG-26 passava, e il controllo sulla forma lo
 aveva reso obbligatorio per sbaglio.
*/
export function telefonoReferenteValido(
  valore: string | undefined | null,
): boolean {
  const telefono = (valore || "").trim();
  return telefono === "" || TELEFONO.test(telefono);
}
